import { useEffect, useRef } from "react";
import { Star, MapPin, Phone, Clock, Globe } from "lucide-react";
import { API } from "@/lib/api";

// A MOCK Indias.com business listing page that embeds the real WebsiteTech Marketing Board
// snippet (served from /api/board.js) exactly as it would appear across the Indias.com network.
export default function BoardDemo() {
  const ref = useRef(null);
  useEffect(() => {
    document.title = "Indias.com · Spice Route Restaurant, Kochi (demo)";
    const s = document.createElement("script");
    s.src = `${API}/board.js`;
    s.defer = true;
    document.body.appendChild(s);
    return () => { s.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Fake Indias.com header */}
      <div className="bg-orange-600 text-white">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <span className="font-heading font-extrabold text-lg tracking-tight">Indias<span className="text-orange-200">.com</span></span>
          <span className="text-xs text-orange-100">Kerala › Ernakulam › Kochi › Restaurants</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="text-xs text-slate-400 mb-1">(This is a sample Indias.com listing page for demo purposes)</div>
        <div className="bg-white rounded-2xl shadow-sm p-6">
          <div className="flex items-start gap-4">
            <div className="w-16 h-16 rounded-xl bg-orange-100 flex items-center justify-center text-2xl">🍽️</div>
            <div>
              <h1 className="font-heading text-2xl font-bold text-slate-900">Spice Route Restaurant</h1>
              <div className="flex items-center gap-1 text-amber-500 text-sm mt-1">
                {[1,2,3,4].map(i => <Star key={i} size={14} fill="currentColor" />)}<Star size={14} /><span className="text-slate-500 ml-1">4.2 (318 reviews)</span>
              </div>
              <p className="text-slate-500 text-sm mt-2 flex items-center gap-1.5"><MapPin size={14} /> MG Road, Kochi, Kerala 682011</p>
            </div>
          </div>
          <div className="grid sm:grid-cols-3 gap-3 mt-5 text-sm text-slate-600">
            <span className="flex items-center gap-2"><Phone size={14} className="text-orange-500" /> +91 98470 12345</span>
            <span className="flex items-center gap-2"><Clock size={14} className="text-orange-500" /> Open · 11am – 11pm</span>
            <span className="flex items-center gap-2"><Globe size={14} className="text-orange-500" /> Kerala cuisine · Seafood</span>
          </div>
        </div>

        {/* >>> Embedded WebsiteTech Marketing Board (contextual: Kerala + Kochi + restaurant) <<< */}
        <div className="mt-6">
          <div
            ref={ref}
            data-wt-board
            data-country="in"
            data-vertical="restaurant"
            data-state="Kerala"
            data-city="Kochi"
            data-page-type="business_listing"
            data-testid="wt-board-embed"
          />
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-6 mt-6">
          <h2 className="font-heading font-bold text-slate-900 mb-2">About</h2>
          <p className="text-sm text-slate-600">Spice Route serves authentic Kerala and coastal seafood in the heart of Kochi. Popular for karimeen pollichathu, appam and traditional sadhya. Family-friendly with outdoor seating.</p>
        </div>

        <div className="text-center text-xs text-slate-400 mt-6">
          The blue promo above is served by <code>/api/board.js</code> — the same snippet Indias.com pages embed. It adapts to each page's state/city/vertical.
        </div>
      </div>
    </div>
  );
}
